<template>
  <v-dialog
    v-model="dialog"
    width="916"
    open-on-focus
    no-click-animation
    persistent
    content-class="stickers-picker-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-toolbar
        flat
        height="76"
      >
        <v-toolbar-title class="stickers-picker-toolbar-title">Add sticker</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          icon
          tile
          @click="closeDialog"
        >
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="stickers-picker-container">
        <v-container>
          <v-row v-masonry="masonryGrid">
            <v-col v-for="(sticker, index) in stickers" :key="`sticker-${index}`" @click="chooseFile(sticker)" cols="12" sm="3">
              <v-img
                :src="sticker.uri"
                :aspect-ratio="sticker.width / sticker.height"
                @load="showDialog ? $redrawVueMasonry(masonryGrid) : null"
                class="sticker__file"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="accent lighten-2"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import StickersMixin from "@/mixins/stickers"

export default {
  name: 'StickersPickerDialog',
  components: {},
  mixins: [ StickersMixin ],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      loading: false,
      masonryGrid: null
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
        setTimeout(() => {
          this.$redrawVueMasonry(this.masonryGrid)
        }, 500);
      } else {
        this.dialog = false
      }
    }
  },
  computed: {},
  created() {},
  methods: {
    closeDialog () {
      this.dialog = false
      this.$emit('close-dialog')
    },
    chooseFile(data) {
      this.$emit('sticker-picked', data)
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.stickers-picker {
  &-container {
    background:$bh-white;
    padding: 0 0.75*$gutter;
    height: calc(100% - 76px); // 76px is height of v-toolbar in v-dialog header
    overflow: auto;
  }
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2*$gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
    }
    .sticker__file {
      cursor: pointer;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
}
</style>
